import { useEffect } from "react";

// Turns `position: sticky` back on for a right-hand rail.
//
// THE PROBLEM. Two of the app shell's own elements declare an overflow —
// `.adminLayout { overflow: hidden }` and `.mainWrapper { overflow-y: auto }`.
// An ancestor with any overflow other than `visible` becomes the sticky
// element's scrollport, so the browser sticks the rail to THAT box instead of
// to the viewport. The box never scrolls (the document does), so the rail never
// moves relative to it and the card simply scrolls away with the page —
// indistinguishable from sticky being ignored. index.css clears the clip under
// `body.league-rail`, gated to >=1024px where dropping it is safe.
//
// THIS HOOK is that flag, and it exists because the flag was set in exactly one
// place. LeagueColumns added the class for a league's Home, Portfolio and
// Watchlist; the Cash Game landing page built its own sticky rail later and had
// no way of knowing the class was the difference — so the client reported "the
// prize card is not sticky" on a page whose CSS was, on its own, entirely
// correct. One import now, rather than a second copy of a body-class effect
// that the next sticky rail would also miss.
//
// Scoped to the lifetime of the screen that calls it, so no other screen ever
// runs with the app shell unclipped.
export const useStickyRail = () => {
  useEffect(() => {
    document.body.classList.add("league-rail");
    return () => document.body.classList.remove("league-rail");
  }, []);
};

export default useStickyRail;
